import React from 'react';
import {Messages} from '../../../../../codegen/Localize';
import {SettingsSection} from '../../../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../SettingsComponentRegistryFunctions';

import {BridgeSiteSettingsSubspaceState} from '../../../../../app/spaces/SiteSettingsSpace/BridgeSiteSettingsSubspace';
import {RemoteRefreshAgents} from '../../../../../ts/resources/RemoteRefreshAgents';
import {useState} from 'react';
import {IRemoteAgentConnectionStatus} from '../../../../../ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import {BridgeRemoteAgentsSectionHeaders} from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSectionHeaders';
import {BridgeRemoteAgentsSectionBody} from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSectionBody';
import {SiteBridgeSettingsForSiteAdminProps} from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';

export function BridgeRemoteAgentsSection(props: SiteBridgeSettingsForSiteAdminProps) {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsAgentsStatus()}
                     testId={'bridge-remote-agents-section'}>
      <table className={'tb-static-grid-table tb-static-grid-table-remote-agents-width'}>
        <BridgeRemoteAgentsSectionHeaders/>
        <BridgeRemoteAgentsSectionBody {... props}/>
        </table>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const BridgeRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeRemoteAgentsSection',
  component: BridgeRemoteAgentsSection
});
